import { ReactComponent as SmilesClubColored } from './smiles-club-colored.svg';
import { ReactComponent as SmilesClub } from './smiles-club.svg';
import { ReactComponent as SmilesLogo } from './smiles-logo.svg';
import { ReactComponent as NewSmilesCLubLogo } from './new-smiles-club.svg';

export default {
  'smiles-club': SmilesClub,
  'smiles-club-colored': SmilesClubColored,
  'smiles-logo': SmilesLogo,
  'new-smiles-club-logo': NewSmilesCLubLogo,
};
